import _ from 'lodash';
import Fuse from 'fuse.js';

const PLAYER_NAME_FIELDS = ['firstName', 'lastName', 'nickname'];

// A fuzzy name matcher over a list of players, or of rows holding a player at `playerPath`.
// A blank term matches the whole list. Build it once per list (memoize it) and call it per term.
export const buildPlayerNameMatcher = <T>(items: T[], playerPath?: string) => {
  const keys = PLAYER_NAME_FIELDS.map(field => (playerPath ? `${playerPath}.${field}` : field));
  const fuse = new Fuse(items, { threshold: 0.3, keys });

  return (term: string): T[] => {
    const query = term.trim();
    return query ? _.map(fuse.search(query), 'item') : items;
  };
};
